export interface AsyncTimeoutType {
  (o: { ms: number }): Promise<unknown>;
}

export const asyncTimeout: AsyncTimeoutType = ({ ms }) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
